import { useState } from "react";
import { Modal, Box, TextField, Button } from "@mui/material";
import { createCompetitor } from "../../../services/competitor-service";
import { useNavigate } from "react-router-dom";
import { modalStyle } from "../../../utils/modal-style";

export default function CreateCompetitorModal({ setOpen, open }) {
  const accessToken = localStorage.getItem("token");
  const [name, setName] = useState("");
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();

    if (!name) alert("Favor preencher o nome do concorrente.");

    try {
      const result = await createCompetitor(accessToken, name);
      console.log(result);
      alert("Concorrente cadastrado com sucesso.");
    } catch (error) {
      if (error.status === 401) {
        alert("Acesso negado. Favor fazer login novamente.");
        navigate("/");
      }
      return alert("Algo deu errado.");
    }
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="box-container" sx={modalStyle}>
          <form onSubmit={handleSubmit} className="form-container">
            <h2>Cadastro de Concorrentes</h2>

            <TextField
              label="Nome"
              name="name"
              onChange={(e) => setName(e.target.value)}
              inputProps={{
                autoComplete: "off",
              }}
            />

            <Button type="submit" variant="contained">
              Cadastrar
            </Button>
          </form>
        </Box>
      </Modal>
    </>
  );
}
